import { render } from "./oaFrameNav.vue?vue&type=template&id=068940c4&scoped=true"
import script from "./oaFrameNav.vue?vue&type=script&lang=js"
export * from "./oaFrameNav.vue?vue&type=script&lang=js"

import "./oaFrameNav.vue?vue&type=style&index=0&id=068940c4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068940c4"]])

export default __exports__